module.exports = ".header-card {\n  margin-left: 5px;\n  margin-bottom: 10px; }\n\n.card-margin {\n  margin: 5px; }\n\n.card-compact {\n  padding: 5px; }\n\n.card-compact h4 {\n  margin: 5px; }\n\n.botton-margin {\n  margin-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/fxs/fxs-picker/fxs-picker.component.scss
// module id = ./src/app/admin/fxs/fxs-picker/fxs-picker.component.scss
// module chunks = main